<template lang="pug">
  .list-user
    b-table(:fields="fields" :items="filterUsers" head-row-variant="light-primary" responsive)
      template(#cell(role)="row")
        | {{getRoleName(row.item.role)}}
      template(#cell(actions)="row")
        .table-actions
          b-btn(@click="openEditModal(row.item)" size="sm" variant="light" style="color: #7F828F")
            font-awesome-icon(:icon="['far', 'edit']" size="lg")
          b-btn(@click="onDelete(row.item)" variant="light" size="sm" style="color: #7F828F")
            font-awesome-icon(:icon="['far', 'trash-alt']" size="lg")
    //- Modal editar usuario
    b-modal(id="edit-modal" size="lg" title="Editar Usuario" hide-footer no-close-on-backdrop)
      create-edit-form(@success="onSuccesEdit" :user="selectedUser" editMode @cancel="$bvModal.hide('edit-modal')")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CreateEditForm from './CreateEditForm'
import userRoles from '../../shared/user_roles.json'

export default {
  components: {
    CreateEditForm
  },
  data () {
    return {
      selectedUser: null,
      fields: [
        {
          key: 'name',
          label: 'Nombre',
          sortable: true
        },
        {
          key: 'lastName',
          label: 'Apellido',
          sortable: true
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true
        },
        {
          key: 'businessGroups',
          label: 'Grupos',
          formatter: (value) => value.map(e => e.name).join(', ')
        },
        {
          key: 'role',
          label: 'Rol',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Acciones'
        }
      ]
    }
  },
  methods: {
    ...mapActions('UserStore', ['listUsers', 'deleteUser']),
    openEditModal (user) {
      this.selectedUser = user
      this.$bvModal.show('edit-modal')
    },
    onSuccesEdit () {
      this.$bvModal.hide('edit-modal')
      this.$bvToast.toast('El usuario se editó correctamente', {
        title: 'Éxito!',
        variant: 'success'
      })
    },
    getRoleName (role) {
      const found = userRoles.find(e => e.role === role)
      if (found) {
        return found.name
      } 
      return ''
    },
    async onDelete (user) {
      const modalMsg = `¿Está seguro que desea eliminar el usuario ${user.name} ${user.lastName}?`
      const modalOptions = {
        title: 'Eliminar Usuario',
        okTitle: 'Eliminar',
        okVariant: 'danger'
      }
      const confirmed = await this.$bvModal.msgBoxConfirm(modalMsg, modalOptions)
      if (confirmed) {
        const { id } = user
        const response = await this.deleteUser(id)
        if (response) {
          this.$bvToast.toast('El usuario se eliminó correctamente', {
            title: 'Éxito!',
            variant: 'success'
          })
        } else {
          this.$bvToast.toast('No se pudo eliminar el usuario', {
            title: 'Oops!',
            variant: 'danger'
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters('UserStore', ['users']),
    filterUsers () {
      return this.users.reduce((acum, user) => 
        user.role !== 'client' ? acum.concat(user) : acum, [])
    }
  },
  created () {
    this.listUsers()
  }
}
</script>